import { atom } from 'nanostores'
import { persistentAtom } from '@nanostores/persistent'

export const isSearchOpen = atom(false)

// Add debug logging to track state changes
isSearchOpen.listen((value) => {
    // Debug logging removed to reduce console noise
});

export const searchTerm = persistentAtom(
    'ma_search_term',
    {},
    {
        encode(searchObj) {
            return JSON.stringify(searchObj)
        },
        decode(searchObj) {
            return JSON.parse(searchObj)
        },
    }
)
